import { SearchTags } from "./SearchTags.component";

export { SearchTags };
